import { createEnvelopeSource } from './create-envelope-source';

/**
 * Engagement source over the standardized envelope (`GET /analytics/engagement`,
 * GA4 to BigQuery). All three are ratios: `repeatVisitRate` renders as a
 * percent, while `sessionsPerUser` (sessions / users) and
 * `avgSessionLengthSeconds` (engagement time / sessions) render their `rate` on
 * a `number` card.
 *
 * `sessionsPerUser` is a ratio and not a scalar average so an empty period
 * renders as unavailable rather than "0 sessions per user", which would claim
 * people were there and opened nothing. `login-activity` publishes a metric of
 * the same name and the same shape, so the two cards cannot disagree about what
 * an empty week means.
 *
 * `province` grain: GA4 geo-IP (`geo.region`) resolves all 13 provinces and
 * territories. It is the device's location, not the account's province, so
 * figures will not match the RPP cohort's exactly.
 *
 * No longer a `split` card. The RPP cohort is its own source
 * (`engagement-rpp`), and that is what recovered a real figure: sharing one
 * envelope forced the RPP province filter to be widened to whole business units
 * so both halves of a card counted the same geography.
 * `avgSessionLengthSeconds` has no RPP twin, so it stays whole-app-only here.
 */
export const engagementSource = createEnvelopeSource({
    label: 'Engagement',
    endpoint: 'analytics/engagement',
    metrics: [
        { id: 'sessionsPerUser', label: 'Sessions per user', type: 'ratio' },
        { id: 'repeatVisitRate', label: 'Repeat visit rate', type: 'ratio' },
        {
            id: 'avgSessionLengthSeconds',
            label: 'Avg session length',
            type: 'ratio',
            isDuration: true,
        },
    ],
    forms: ['number', 'rate'],
    regionGrain: 'province',
});
